export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/b3dc542ec1b5794376b3d1da54a4e35b.svg";